export default __webpack_public_path__ + "static/media/under_construction.b8ad20df.png";